import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { Healthcheck } from '../common/types.tsx';

export const getHealthcheck = (): Promise<Healthcheck> =>
	fetchJson('/rest/applinks/latest/applicationlink/extraAuth/healthcheck');
